// extracted by mini-css-extract-plugin
export var askAiIcon = "_ju-9";
export var container = "_ju-0";
export var groupSeparator = "_ju-a";
export var highlight = "_ju-4";
export var resultIcon = "_ju-5";
export var resultItem = "_ju-7";
export var resultSubtitle = "_ju-3";
export var resultTitle = "_ju-2";
export var resultsList = "_ju-1";
export var searchGroup = "_ju-6";
export var selected = "_ju-8";